export const LocalStorage = {
  ResolutionFlag: 'ResolutionFlag',
  ScreenWidthFlag: 'ScreenWidthFlag',
  AutoTabIndication: 'AutoTabIndication',
  SubmissionsView: 'SubmissionsView',
  SubmissionsBox: 'SubmissionsBox',
  ToolboxSize: 'ToolboxSize',
  InfoTooltip: 'InfoTooltip',
  ActivateOnce: 'ActivateOnce',
  FastTrackBannerSubmissionsDismissed: 'FastTrackBannerSubmissionsDismissed',
  StartMarketingIndicator: 'StartMarketingIndicator',
  MarketRequestSortType: 'MarketRequestSortType',
  ReviewRenewalSubmissionDismissed: 'ReviewRenewalSubmissionDismissed',
} as const;

export type LocalStorageKeys = keyof typeof LocalStorage;
